<template>
  <div>
    <div v-if="articleList.length > 0">
      <el-table :data="articleList" :header-cell-style="{
background: '#E8F4FE'}" :cell-style="{
'height': '60px','cursor': 'default'}" :stripe="true" style="width: 100%">
        <el-table-column label="标题" align="left" header-align="center">
          <template slot-scope="scope">
            <!-- <span style="margin-left: 10px">{{ scope.row.date }}</span> -->
            <span style="color: #4190F6;padding-left: 20px;display: block;word-wrap: normal;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;cursor: pointer;" @click="jumpArticleDetail(scope.row)">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="行业" align="left" header-align="center" width="200" key="labelNames" prop="labelNames" />
        <el-table-column label="时间" align="left" header-align="center" width="100" key="date" prop="date" />
        <el-table-column label="来源" align="center" header-align="center" width="150" key="source" prop="source" />
        <el-table-column label="收藏" align="center" header-align="center" width="80">
          <!-- <template slot-scope="scope">
      </template> -->
          <img src="../assets/imgs/star_grey@2x.png" style="width:17px;">
        </el-table-column>
        <el-table-column label="查看" align="center" header-align="center" width="80">
          <template slot-scope="scope">
            <!-- <span style="margin-left: 10px">{{ scope.row.date }}</span> -->

            <span style="color: #4190F6;cursor: pointer;" @click="jumpArticleDetail(scope.row)">查看</span>
          </template>
          <!-- <img src="../assets/imgs/pdf@2x.png" style="width:20px"> -->
        </el-table-column>
      </el-table>

      <el-pagination align='right' @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20]" :page-size="pageSize" layout="total, prev, pager, next" :total="total" style="margin-top:10px">
      </el-pagination>
    </div>
    <div class="none_page" v-else>
      <img src="../assets/imgs/none.png">
    </div>
  </div>
</template>

<script>
import { apiGet,apiPost } from "../assets/http";
import { mapGetters } from "vuex";
export default {
  props: ['searchValue','searchType'],
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      articleList: [],
      // columnId: "",
      // labelIds: [],
      oldColumnId: "",
    };
  },
  computed: {
    ...mapGetters(["showStyle", "columnId", "labelIds"]),
  },
  watch: {
    // showStyle(newData, oldData) {
    //   console.log(newData, oldData, "showStyle");
    //   // console.log(this.$store.state.showStyle);
    //   // this.getArticleList();
    // },
    columnId(newData, oldData) {
      console.log(newData, oldData, "columnId");
      // this.oldColumnId = oldData;
      // this.getArticleList();
      // console.log(this.$store.state.columnId);
    },
    labelIds(newData, oldData) {
      console.log(this.columnId);
      if (
        this.columnId != this.oldColumnId ||
        oldData.length > 0 ||
        newData.length > 0
      ) {
        this.getArticleList();
      }
    },
  },
  created() {
    console.log(this.searchValue)
    this.getArticleList();
  },
  methods: {
    getArticleList() {
      console.log("listlist")
      apiGet("/business/web/getSysConfig", { key: "sys.list.count" }).then(
        (val) => {
          this.pageSize = Number(val.data.value);
          apiPost("/business/web/getArticleList", {
            columnId: this.columnId,
            labelIds: this.labelIds ? this.labelIds : [],
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            key: this.searchValue || "",
            type: this.searchType || "",
          }).then((res) => {
            // res.rows.forEach((item) => {
            //   let str = "";
            //   item.labelNames.forEach((item1, index) => {
            //     if (index == item.labelNames.length - 1) {
            //       str += item1;
            //     } else {
            //       str += item1 + " | ";
            //     }
            //   });
            //   item.labelNames = str;
            // });
            // this.articleList = res.rows;
            // this.total = res.total;
            // console.log(this.articleList, "list");
            // loading.close();
          });
        }
      );
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.pageSize = val;
      this.getArticleList();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getArticleList();
    },
    jumpArticleDetail(row) {
      if (row.link != null) {
        window.open(row.link, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: "/article",
          name: "article",
          query: { articleId: row.articleId },
        });
        window.open(routeUrl.href, '_blank');
      }
    },
  },
};
</script>

<style>
.el-table{
  font-family: 思源黑体 Normal !important;
}
/* striped先开启斑马纹属性，这里是修改斑马纹颜色 */
.el-table__row--striped td {
  background-color: #f2f2f2 !important;
}

.el-table__row {
  background-color: #ffffff !important;
}

/* 斑马纹颜色定义完之后会显示自带的边框颜色，这里要重置 */
.el-table td,
.building-top .el-table th.is-leaf {
  border: none;
  /* color: white; */
}

.search .el-input input {
  width: 120px;
  height: 32px;
  border: 1px solid #aeaeae;
  border-right: 0;
  border-radius: 0;
}
.search .el-input__icon {
  line-height: 33px;
}
.search .el-input .el-input__inner {
  border-color: #aeaeae !important;
}
</style>